import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { DxDataGridModule, DxTemplateModule } from "devextreme-angular";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { PanelsModule } from "src/app/shared/panels/panels.module";
import { FocusingModule } from "src/app/shared/ui/forms/inputs/focusing.module";
import { Select2Module } from "src/app/shared/ui/forms/inputs/oops-select2/select2.module";
import { UiModule } from "src/app/shared/ui/ui.module";
import { InsightLanguageDetailComponent } from "./detail/language-detail.component";
import { LanguageDetailDirective } from "./detail/language.directive";
import { InsightDetailLanguageComponent } from "./insight-detail-language.component";
import { InsightLanguageTableComponent } from "./table/language-table.component";

@NgModule({
    declarations: [
        InsightDetailLanguageComponent,
        InsightLanguageDetailComponent,
        InsightLanguageTableComponent,
        LanguageDetailDirective
    ],
    exports: [
        InsightDetailLanguageComponent,
        InsightLanguageDetailComponent,
        InsightLanguageTableComponent,
        LanguageDetailDirective
    ],
    imports: [
        ButtonsModule,
        CollapseModule,
        CommonModule,
        FocusingModule,
        FormsModule,
        DxDataGridModule,
        DxTemplateModule,
        MatIconModule,
        PanelsModule,
        Select2Module,
        UiModule
    ],
    providers: []
})
export class LanguageModule {    
}